module.exports = __webpack_public_path__ + "img/food-hero-business.bf16cde7.jpg";